import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { getApiUrl, API_URL } from '@/utils/api';
import ApiBase from './ApiBase';

export default class SlideService extends ApiBase {
  static baseUrl = getApiUrl(API_URL.ADMIN, '/slides');

  getCurrentSlideData(storeId: string) {
    const searchParams = new URLSearchParams({ storeId });

    return this.api.getJSON(`${SlideService.baseUrl}/slideActivebyStoreId?${searchParams.toString()}`).pipe(
      catchError(() => of([]))
    );
  }

  getCurrentSlideMData(storeId: string) {
    const searchParams = new URLSearchParams({ storeId });

    return this.api.getJSON(`${SlideService.baseUrl}/slideMActivebyStoreId?${searchParams.toString()}`).pipe(
      catchError(() => of([]))
    );
  }

  getCurrentDpData(storeId: string) {
    const searchParams = new URLSearchParams({ storeId });

    return this.api.getJSON(`${SlideService.baseUrl}/dpActivebyStoreId?${searchParams.toString()}`).pipe(
      catchError(() => of([]))
    );
  }
}
